import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import guide from '@/components/guide'
import setinfo from '@/components/setinfo'
import mybaogao from '@/components/mybaogao'
import ordermanagement from '@/components/ordermanagement'
import payment from '@/components/payment'
import successfulpayment from '@/components/successfulpayment'
import startTest from '@/components/startTest'
import gamelist from '@/components/gamelist'
import gameover from '@/components/gameover'
import viewreport from '@/components/viewreport'
import reportpage from '@/components/reportpage'
import pay from '@/components/pay'
import carrypay from '@/components/carrypay'
import print from '@/components/print'
import payQuest from '@/components/payQuest'
import payWeChat from '@/components/payWeChat'
import cardSucc from '@/components/cardSucc'
import setpassword from '@/components/setpassword'
import mechanismPrin from '@/components/mechanismPrin'
import mechanismCard from '@/components/mechanismCard'

import pindex from '@/phonecomponents/pindex'
import home from '@/phonecomponents/home'
import pmybaogao from '@/phonecomponents/mybaogao'
import ppayment from '@/phonecomponents/payment'
import pordermanagement from '@/phonecomponents/ordermanagement'
import psetinfo from '@/phonecomponents/setinfo'
import report from '@/phonecomponents/report'
Vue.use(Router)

var CW = document.body.clientWidth;
var routerArr = null;
// console.log(CW)
if(CW <= 500){
//   console.log(0)
  routerArr = [
        {
          path: '/',
          name: 'pindex',
          component: pindex,
          children: [
              {
                    path: '/',
                    component: home
              },
              {
                    path: '/pmybaogao',
                    component: pmybaogao
              },
              {
                path: '/ppayment',
                component: ppayment
              },
              {
                  path: '/pordermanagement',
                  component: pordermanagement
              },
              {
                    path: "/psetinfo",
                    component: psetinfo
              },
              {
                    path: "/report",
                    component: report
              }
          ]
        }
    ]
}else{
  routerArr = [
        {
          path: '/',
          name: 'index',
          component: index,
          children: [
              {
                    path: '/',
                    component: guide
              },
              {
                    path: '/mybaogao',
                    component: mybaogao
              },
              {
                    path: '/setinfo',
                    component: setinfo
              },
              {
                    path: '/ordermanagement',
                    component: ordermanagement
              },
              {
                    path: '/payment',
                    component: payment
              },
              {
                    path: '/successfulpayment',
                    component: successfulpayment
              },
              {
                    path: '/cardSucc',
                    component: cardSucc
              },
              {
                    path: '/startTest',
                    component: startTest
              },
              {
                    path: '/payWeChat',
                    component: payWeChat
              },
              {
                    path: '/gamelist',
                    component: gamelist
              },
              {
                    path: '/gameover',
                    component: gameover
              },
              {
                    path: '/viewreport',
                    component: viewreport
              },
              {
                    path: '/mechanismCard',
                    component: mechanismCard
              },
              {
                  path: '/reportpage',
                  component: reportpage
            },
            {
                  path: '/mechanismPrin',
                  component: mechanismPrin
            },
              {
                    path: '/pay',
                    component: pay
              },
              {
                    path: '/carrypay',
                    component: carrypay
              },
             {
                    path: '/payQuest',
                    component: payQuest
              },
              {
                path: '/setpassword',
                component: setpassword
              }
          ],
        },
        {
          	path: '/print',
            component: print
          }
    ]
}
export default new Router({
  saveScrollPosition: true, //记住页面的滚动位置 html5模式适用
    routes: routerArr
})




// WEBPACK FOOTER //
// ./src/router/index.js